import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createSalaryComponent = async (data) => {
  const res = await axiosInstance.post("/api/salary-components/create", data);
  return res.data;
};

export const getAllSalaryComponents = async (filters = {}) => {
  const res = await axiosInstance.get("/api/salary-components/all", { params: filters });
  return res.data;
};

export const updateSalaryComponent = async (id, data) => {
  const res = await axiosInstance.put(`/api/salary-components/update/${id}`, data);
  return res.data;
};

export const toggleSalaryComponentActive = async (id) => {
  const res = await axiosInstance.put(`/api/salary-components/toggle/${id}`);
  return res.data;
};
